module.exports = __webpack_public_path__ + "img/teacherResource-3.6e10adf4.jpg";